// @ts-nocheck
import type { Question } from '../types';

export const signIdentificationQuestions: Question[] = [
  {
    id: 'q-identify-sign-1',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-sign-1o1', text: 'Traffic light ahead' },
      { id: 'q-sign-1o2', text: 'Road narrows ahead' },
      { id: 'q-sign-1o3', text: 'Entry not allowed / forbidden (checkpoint)' }
    ],
    answerId: 'q-sign-1o1',
    explanation: 'This warning sign indicates a traffic light ahead. The triangular shape with red border and traffic light symbol warns drivers to be prepared to stop if the light is red.',
    subject: 'Sign Identification',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-1.jpg',
    imageHint: 'warning sign traffic light ahead'
  },
  {
    id: 'q-identify-sign-2',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-sign-2o1', text: 'Entry not allowed / forbidden (checkpoint)' },
      { id: 'q-sign-2o2', text: 'Rail crossing ahead with more than 1 railway' },
      { id: 'q-sign-2o3', text: 'Rail crossing ahead with 1 railway' }
    ],
    answerId: 'q-sign-2o2',
    explanation: 'This is a railway crossing sign indicating multiple railway tracks ahead. Drivers must stop if a train is approaching and never cross when barriers are down or warning lights are flashing. Multiple tracks mean extra caution is required.',
    subject: 'Sign Identification',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-2.jpg',
    imageHint: 'warning sign railroad crossing multiple tracks'
  },
  {
    id: 'q-identify-sign-3',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-sign-3o1', text: 'Road narrows ahead' },
      { id: 'q-sign-3o2', text: 'Road gets narrow on the right side' },
      { id: 'q-sign-3o3', text: 'Road narrows on the left' }
    ],
    answerId: 'q-sign-3o1',
    explanation: 'This warning sign indicates that the road narrows ahead. The triangular shape with red border and converging lines symbol warns drivers to reduce speed and be cautious when approaching a narrowing road.',
    subject: 'Sign Identification',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-3.jpg',
    imageHint: 'warning sign road narrowing'
  },
  {
    id: 'q-identify-sign-4',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-sign-4o1', text: 'Warning for low flying planes, aircraft and jets' },
      { id: 'q-sign-4o2', text: 'Traffic light ahead' },
      { id: 'q-sign-4o3', text: 'Warning for pedestrians' }
    ],
    answerId: 'q-sign-4o1',
    explanation: 'This warning sign indicates low-flying aircraft, planes, and jets. The triangular shape with red border and airplane symbol warns drivers to be aware of aircraft that may be flying at low altitudes.',
    subject: 'Sign Identification',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-4.jpg',
    imageHint: 'warning sign low-flying aircraft'
  },
  {
    id: 'q-identify-sign-5',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-sign-5o1', text: 'Stop and give way to all traffic' },
      { id: 'q-sign-5o2', text: 'Give way to all traffic' },
      { id: 'q-sign-5o3', text: 'Priority road' }
    ],
    answerId: 'q-sign-5o1',
    explanation: 'This is a stop sign (red octagon with white "STOP" text). Drivers must come to a complete stop and give way to all traffic before proceeding. This is one of the most important regulatory signs.',
    subject: 'Sign Identification',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-5.jpg',
    imageHint: 'stop sign'
  },
  {
    id: 'q-identify-sign-6',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-sign-6o1', text: 'Crossing for pedestrians warning ahead' },
      { id: 'q-sign-6o2', text: 'Warning for pedestrians' },
      { id: 'q-sign-6o3', text: 'Cattle crossing' }
    ],
    answerId: 'q-sign-6o1',
    explanation: 'This warning sign indicates a pedestrian crossing (zebra crossing) ahead. The triangular shape with red border and pedestrian symbol on stripes warns drivers to slow down and be prepared to yield to pedestrians.',
    subject: 'Sign Identification',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-6.jpg',
    imageHint: 'warning sign pedestrian crossing zebra'
  },
  {
    id: 'q-identify-sign-7',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-sign-7o1', text: 'Warning of poor visibility due to rain, fog or snow' },
      { id: 'q-sign-7o2', text: 'Warning for snow and sleet' },
      { id: 'q-sign-7o3', text: 'Cattle crossing' }
    ],
    answerId: 'q-sign-7o1',
    explanation: 'This warning sign indicates poor visibility conditions ahead due to rain, fog, or snow. The triangular shape with red border and car symbol with dots/particles warns drivers to reduce speed and increase following distance.',
    subject: 'Sign Identification',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-7.jpg',
    imageHint: 'warning sign poor visibility weather'
  },
  {
    id: 'q-identify-sign-8',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-sign-8o1', text: 'Cattle crossing' },
      { id: 'q-sign-8o2', text: 'Warning for pedestrians' },
      { id: 'q-sign-8o3', text: 'Crossing for pedestrians warning ahead' }
    ],
    answerId: 'q-sign-8o1',
    explanation: 'This warning sign indicates a cattle crossing ahead. The triangular shape with red border and cow symbol warns drivers to be alert for cattle that may be crossing the road. Drivers should reduce speed and be prepared to stop.',
    subject: 'Sign Identification',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-8.jpg',
    imageHint: 'warning sign cattle crossing'
  },
  {
    id: 'q-identify-sign-9',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-sign-9o1', text: 'Cars not allowed - prohibited' },
      { id: 'q-sign-9o2', text: 'Vehicles - Cars prohibited' },
      { id: 'q-sign-9o3', text: 'Entry not allowed / forbidden (checkpoint)' }
    ],
    answerId: 'q-sign-9o1',
    explanation: 'This prohibitory sign indicates that cars are not allowed and are prohibited from entering or using this road or area. The sign shows a car symbol with a diagonal line through it, indicating that motor vehicles are forbidden.',
    subject: 'Sign Identification',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-9.jpg',
    imageHint: 'prohibitory sign cars not allowed'
  },
  {
    id: 'q-identify-sign-10',
    topic: 'General',
    question: 'Identify the road sign:',
    options: [
      { id: 'q-sign-10o1', text: 'Crossroad ahead with side road to left' },
      { id: 'q-sign-10o2', text: 'Crossroad ahead, side roads to right and left' },
      { id: 'q-sign-10o3', text: 'Uncontrolled crossroad ahead' }
    ],
    answerId: 'q-sign-10o1',
    explanation: 'This warning sign indicates a crossroad ahead with a side road joining from the left. The triangular shape with red border and road junction symbol warns drivers to be alert for traffic entering from the left side road. Drivers should reduce speed and be prepared to yield if necessary.',
    subject: 'Sign Identification',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-10.jpg',
    imageHint: 'warning sign crossroad side road left'
  },
  {
    id: 'q-identify-sign-18',
    topic: 'General',
    question: 'What information might be added below a main road sign?',
    options: [
      { id: 'q-sign-18o1', text: 'Only advertising' },
      { id: 'q-sign-18o2', text: 'Supplementary plates with conditions, distances, or times' },
      { id: 'q-sign-18o3', text: 'Random messages' }
    ],
    answerId: 'q-sign-18o2',
    explanation: 'Supplementary plates below road signs provide additional information such as distance, time periods, conditions, or affected vehicle types. These help clarify when or how the main sign applies.',
    subject: 'Sign Identification'
  },
];
